import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PRIVACY_HIDE_RECRUITER = createFcmConfig('privacy_hide_recruiter', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
